<template>
  <div :style="guidancePosition" class="guidance-button">
    <v-tooltip v-model="showGuidanceTooltip" z-index="200" top attach>
      <template v-slot:activator="{ attrs }">
        <v-btn
          @click="toggleGuidance()"
          v-bind="attrs"
          class="floating-button mt-2"
          icon
        >
          <v-icon class="button-icon">$iconQuestionMark</v-icon>
        </v-btn>
      </template>
      <div class="d-flex flex-column align-end py-3">
        <span class="body2">{{ $t("guidance.tooltip.content") }}</span>
        <niko-button
          :text="$t('guidance.tooltip.button')"
          @onClick="hideTooltip"
          class="mt-3"
          primary
        />
      </div>
    </v-tooltip>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { eventBus } from "@/components/EventBus";
import NikoButton from "@/components/UI/NikoButton";

export default {
  name: "guidance-button",
  props: {
    page: String,
    bottom: { type: String, default: "24" },
    right: { type: String, default: "24" },
  },
  components: { NikoButton },
  computed: {
    ...mapState("authStore", ["showGuidanceTooltip"]),
    guidancePosition() {
      return {
        bottom: this.bottom + "px",
        right: this.right + "px",
      };
    },
  },
  methods: {
    ...mapActions("authStore", ["setGuidanceAttribute"]),
    toggleGuidance() {
      eventBus.$emit("toggleGuidance", this.page);
    },
    hideTooltip() {
      this.setGuidanceAttribute();
    },
  },
};
</script>

<style lang="scss">
.guidance-button {
  position: fixed;

  .floating-button {
    background: rgba(255, 255, 255, 0.1);
    height: 40px !important;
    width: 40px !important;

    .button-icon {
      height: 20px !important;
      width: 20px !important;
    }
  }
  .v-tooltip__content {
    pointer-events: initial;
    top: initial !important;
    left: initial !important;
    position: absolute;
    width: 240px;
    bottom: 60px;
    right: -12px;

    &:after {
      content: "";
      border-top: 12px solid rgba(97, 97, 97, 0.9);
      border-left: 12px solid transparent;
      border-right: 12px solid transparent;
      position: absolute;
      bottom: -12px;
      right: 20px;
    }
  }
}
</style>
